import { useEffect } from 'react'

import { $isAutoLinkNode, AutoLinkNode } from '@lexical/link'
import { AutoLinkPlugin as AutoLink } from '@lexical/react/LexicalAutoLinkPlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getNodeByKey } from 'lexical'

// use your own matchers
const URL_MATCHER =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

const MATCHERS = [
  (text: string) => {
    const match = URL_MATCHER.exec(text)
    if (match === null) {
      return null
    }
    const fullMatch = match[0]
    return {
      index: match.index,
      length: fullMatch.length,
      text: fullMatch,
      url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`,
    }
  },
]

export const AutoLinkPlugin = (): JSX.Element => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!editor) return
    const removeNodeListener = editor.registerMutationListener(AutoLinkNode, mutatedNodes => {
      mutatedNodes.forEach((mutation, nodeKey) => {
        if (mutation === 'created') {
          // eslint-disable-next-line max-nested-callbacks
          editor.update(() => {
            const node = $getNodeByKey(nodeKey)
            if ($isAutoLinkNode(node)) {
              node.setTarget('_blank')
              node.setRel('noopener noreferrer')
            }
          })
        }
      })
    })
    return () => removeNodeListener()
  }, [editor])

  return <AutoLink matchers={MATCHERS} />
}
